import React, { useEffect, useState } from "react";
import { Invoice } from "../../interfaces/invoice";
import { useNavigate } from "react-router-dom";
import {
  generateRevenueReport,
  getIndividualInvoices,
  getInvoices,
} from "../../services/invoiceServices";
import GenerateInvoice from "../../components/admin-components/GenerateInvoice";
import ToolTip from "../../components/component-tools/ToolTip";

const Invoicing = () => {
  const [loading, setLoading] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const navigate = useNavigate();
  const [showInvoicePopup, setShowInvoicePopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchInvoicingData = async () => {
      try {
        setLoading(true);
        const invoicesResponse = await getInvoices();
        setInvoices(invoicesResponse);
      } catch {
        console.log("error fetching invoices");
      } finally {
        setLoading(false);
      }
    };
    fetchInvoicingData();
  }, []);

  const handleGenerateRevenueReport = async () => {
    try {
      setLoadingSpinner(true);
      const individualInvoicesResponse = await getIndividualInvoices();

      if (individualInvoicesResponse) {
        const responseUrl = await generateRevenueReport(
          individualInvoicesResponse,
        );

        if (responseUrl) {
          const url = window.URL.createObjectURL(responseUrl);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Invoice.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setLoading(false);
        } else {
          setErrorMessage("Failed to generate PDF.");
        }
      }
    } catch (error) {
      setErrorMessage("Failed to generate invoice report.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <div className="content-container">
      <div className="header-container">
        <h1 style={{ display: "flex" }}>
          Invoicing
          <ToolTip
            tooltipText="Generate a Revenue Report FIRST before Generating an Invoice."
            placement="right"
            className="info-icon"
          />
        </h1>
        <div className="page-items-container">
          <button
            className="oxbtn btn-grey"
            onClick={() => handleGenerateRevenueReport()}
          >
            Generate Revenue Report
          </button>
          <button
            className="oxbtn btn-grey"
            onClick={() => setShowInvoicePopup(true)}
          >
            Generate Invoice
          </button>
        </div>

        {showInvoicePopup && (
          <GenerateInvoice
            invoices={invoices}
            onClose={() => {
              setShowInvoicePopup(false);
              window.location.reload();
            }}
          />
        )}
      </div>

      {loading ? (
        <div className="loading-divider">
          <div className="loading-bar"></div>
        </div>
      ) : (
        <>
          <div className="divider"></div>
          <div style={{ display: "flex", gap: "30px", justifyContent: "end" }}>
            <div>
              <b>Step One:</b> Generate Revenue Report
            </div>
            <div>
              <b>Step Two:</b> Generate Invoice
            </div>
          </div>
          <br></br>
          <div className="table-wrapper">
            <div className="table-container">
              <table className="table" style={{ cursor: "pointer" }}>
                <thead>
                  <tr>
                    <th style={{ width: "200px" }}>Client Name</th>
                    <th style={{ width: "200px" }}>Candidate Name</th>
                    <th style={{ width: "150px" }}>Type</th>
                    <th style={{ width: "150px" }}>Total</th>
                    <th style={{ width: "150px" }}>OrderID</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices?.length === 0 ? (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center" }}>
                        No Invoices found.
                      </td>
                    </tr>
                  ) : (
                    invoices?.map((invoice, index) => {
                      return (
                        <tr
                          key={index}
                          onClick={() =>
                            navigate(`/admin/view-order/${invoice.orderID}`)
                          }
                        >
                          <td>{invoice.clientName}</td>
                          <td>{invoice.candidateName}</td>
                          <td>{invoice.type}</td>
                          <td>{invoice.total}</td>
                          <td>{invoice.orderID}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
      {errorMessage && (
        <div
          className="alert-message alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {errorMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setErrorMessage("")}
            aria-label="Close"
          ></button>
        </div>
      )}
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default Invoicing;
